/** Custom config file for Image blot of quill-editor. */
import ReactQuill from 'react-quill';

/** https://stackoverflow.com/questions
 * /77911301/image-resize-using-quill-blot-formatter-package-restricts-the-scrolling-in-the-r */
const BaseImage = ReactQuill.Quill.import('formats/image');

/** 'height' can be added, so it will be saved in each element. But then need to remove 'static create' */
const ATTRIBUTES = ['alt', 'width', 'style', 'data-align'] as const;

type AttributeKey = (typeof ATTRIBUTES)[number];

class CustomImage extends BaseImage {
  /** Using 'create' to replace default height prop with 'auto' */
  static create(value: string) {
    const node = super.create(value) as HTMLImageElement;

    // Optional: remove any height that may have been added by default or pasted
    node.removeAttribute('height');
    node.style.height = 'auto'; // Ensure natural scaling

    return node;
  }

  static formats(domNode: HTMLElement): Partial<Record<AttributeKey, string>> {
    return ATTRIBUTES.reduce((formats, attribute) => {
      const attr = domNode.getAttribute(attribute);

      if (attr) {
        // eslint-disable-next-line no-param-reassign
        formats[attribute] = attr;
      }

      return formats;
    }, {} as Partial<Record<AttributeKey, string>>);
  }

  format(name: string, value: string | null) {
    if ((ATTRIBUTES as readonly string[]).includes(name)) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

ReactQuill.Quill.register(CustomImage, true);
